import { render } from "./CompareUpsellSheet.vue?vue&type=template&id=0b5731da&scoped=true"
import script from "./CompareUpsellSheet.vue?vue&type=script&lang=js"
export * from "./CompareUpsellSheet.vue?vue&type=script&lang=js"

import "./CompareUpsellSheet.vue?vue&type=style&index=0&id=0b5731da&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5731da"]])

export default __exports__